import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Link } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';

function ArticlesPreview() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://api.wajls.com/client/v1/fetch_articles_ojs.php")
      .then((response) => {
        setArticles(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load articles.");
        setLoading(false);
      });
  }, []);

  return (
    <Box sx={{ px: 2, py: 3, maxWidth: 'lg', mx: "auto" }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: "#e65100",
          borderBottom: "1px solid #e0e0e0",
          mb: 2,
        }}
      >
        Recently Published Articles
      </Typography>

      {loading ? (
        <>
          {[...Array(4)].map((_, i) => (
            <Box key={i} sx={{ mb: 2 }}>
              <Skeleton variant="text" width="80%" height={24} />
              <Skeleton variant="text" width="60%" height={20} />
            </Box>
          ))}
        </>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : articles.length === 0 ? (
        <Typography>No articles found</Typography>
      ) : (
        <>
          {articles.map((article) => (
            <Box
              key={article.submission_id}
              sx={{
                mb: 2,
                pb: 1,
                borderBottom: "1px solid #eee",
              }}
            >
              <Link
                href={`https://journal.wajls.com/index.php/home/article/view/${article.submission_id}`}
                underline="hover"
                color="primary"
                sx={{ fontWeight: 600, display: 'block', fontSize: '1rem' }}
                // target="_blank"
                // rel="noopener noreferrer"
              >
                {article.title}
              </Link>

              {article.authors?.length > 0 && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  Authors:{' '}
                  {article.authors.map((author, i) => (
                    <span key={i}>
                      {author.name}
                      {i < article.authors.length ? '; ' : ''}
                    </span>
                  ))}
                </Typography>
              )}
            </Box>

          ))}


        <Link
          href="https://journal.wajls.com/"
          underline="always"
          sx={{
            mt: 2,
            fontSize: '0.9rem',
            fontWeight: 500,
            color: 'blue',
            textAlign: 'right',
            display: 'block',
            cursor: 'pointer',
          }}
        >
          Browse More Articles
        </Link>
        </>
      )}
    </Box>
  );
}

export default ArticlesPreview;
